const dividerCellClasses = 'p-0!';

// Flat hairline: the old cyan-to-teal border-image gradient was a leftover from
// the previous brand and read as a green line between rows.
const dividerClasses = "h-px bg-border-light";

const TableRowDivider = ({ colSpan = 5 }) => (
    <tr>
        <td colSpan={colSpan} className={dividerCellClasses}>
            <div className={dividerClasses}></div>
        </td>
    </tr>
);

export default TableRowDivider;
